import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rSorgulamaSonuclari } from '../../models/.catalog';
import rList from '../../models/rList';

export default class TiklamaSonuclariApi extends ApiBase<pList, rList<rSorgulamaSonuclari>> {
    constructor(options?: Options) {
        super(
            new MethodInfo({
                MethodUrl: '/ListeleGrafikMobil',
            }),
            options
        );
    }
}
